import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import Badge from 'react-bootstrap/Badge'

import Imagen from '../imagen/Imagen'

const PRESUPUESTO_PAGADO = 2
const PRESUPUESTO_EN_PREPARACION = 3

const PresupuestoCabecera = ({ presupuesto, estado, estadoTxt, canAdministrate }) => {
  const [estadoTipo, setEstadoTipo] = useState('')

  const { idEstado, estado: estadoPresupuesto, titulo, idPublicacion } = presupuesto

  const updateEstado = () => {
    let newEstado
    switch (estado !== null ? estado : idEstado) {
      case 0:
        newEstado = 'secondary'
        break
      case 1:
        newEstado = 'warning'
        break
      case PRESUPUESTO_PAGADO:
        newEstado = 'success'
        break
      case PRESUPUESTO_EN_PREPARACION:
        newEstado = 'info'
        break
      default:
        newEstado = 'secondary'
    }
    setEstadoTipo(newEstado)
  }

  useEffect(() => {
    updateEstado()
  }, [])

  return (
    <div>
      <div className="row">
        <div className="col text-right mt-1 mr-2"></div>
      </div>
      <div className="row">
        <div className="col-4 col-md-3 contenedor-img-detalle">
          <Imagen idPublicacion={idPublicacion} width={100}></Imagen>
        </div>
        <div className="col">
          <h2 className="vendedor-detalle">{titulo}</h2>
          {canAdministrate && (
            <h2>
              <Badge variant={estadoTipo}>
                {estadoTxt !== null ? estadoTxt : estadoPresupuesto}
              </Badge>
            </h2>
          )}
        </div>
      </div>
    </div>
  )
}

PresupuestoCabecera.propTypes = {
  presupuesto: PropTypes.shape({
    idEstado: PropTypes.number.isRequired,
    estado: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    idPublicacion: PropTypes.number.isRequired
  }).isRequired,
  estado: PropTypes.number,
  estadoTxt: PropTypes.string
}

export default PresupuestoCabecera

PresupuestoCabecera.propTypes = {
  presupuesto: PropTypes.shape({
    idEstado: PropTypes.number,
    estado: PropTypes.string,
    titulo: PropTypes.string,
    idPublicacion: PropTypes.number
  }).isRequired,
  estado: PropTypes.number,
  estadoTxt: PropTypes.string,
  canAdministrate: PropTypes.bool.isRequired
}
